module.exports = __webpack_public_path__ + "static/img/szafa_22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_22.svg
// module id = amsx
// module chunks = 0